/* eslint-disable jsx-a11y/no-static-element-interactions */
const React = require('react');
const Collapse = require('../../../Sidebar/images/Collapse');
const { getEventTracker } = require('../../../../../utils/event-tracker');

const { useState, useRef, useEffect } = React;

const ErrorItem = ({ property, lang, onUpdate = () => {} }) => {
  const Tracker = getEventTracker();
  const errorItemChildrenRef = useRef(null);

  const [showChildProps, setShowChildProps] = useState(false);

  useEffect(() => {
    onUpdate();
  }, [showChildProps]);

  const toggleChilds = () => {
    errorItemChildrenRef.current.classList.add(`error-item__children--${!showChildProps ? 'visible' : 'invisible'}`);
    errorItemChildrenRef.current.classList.remove(`error-item__children--${!showChildProps ? 'invisible' : 'visible'}`);
    setShowChildProps(!showChildProps);

    Tracker.send('mpdevelopers/toggle_content_params_child', showChildProps ? 'hide' : 'show');
  };

  return (
    <div className="error-item">
      <div className="error-item__header" onClick={toggleChilds}>
        <p className="error-item-title">
          <span className="error-item-title__code">{property?.name}</span>
          <span className="error-item-title__description">{property?.description ? property?.description[lang] : ''}</span>
        </p>
        <Collapse className={showChildProps ? 'icon__uncollapsed' : 'icon__collapsed'} />
      </div>
      <div ref={errorItemChildrenRef} className="error-item__children">
        {property.properties?.map(
          item => (
            <div className="error-item__children__item">
              <p className="error-item__children__title">{item.title}</p>
              <p className="error-item__children__description">{item.description[lang]}</p>
              {item?.enum?.map((data => (
                <div className="error-item__enum__sub">
                  <p className="error-item__enum__sub-title">{data.title}:</p>
                  <span className="error-item__enum__sub-description">{data.description[lang]}</span>
                </div>
              )))}
            </div>
          ),
        )}
      </div>
    </div>
  );
};

module.exports = ErrorItem;
